import i18n from '@/i18n'

/**
 * Getters the components shared with Funeral Manager read (phone input,
 * table headers, tab errors). Crema has no initial-metadata endpoint: they
 * are derived from the system settings received at login.
 */
export default {
  namespaced: true,
  state() {
    return {}
  },
  getters: {
    getInitialMetadata(state, getters, rootState) {
      return { settings: rootState.settings?.systemSettings ?? {} }
    },
    getDefaultCountry(state, getters, rootState) {
      return rootState.settings?.systemSettings?.default_country ?? 'BE'
    },
    // BaseShowEditTranslation's languages: the crematorium's, plus its
    // default and the interface's (fr_BE labels while only fr_FR is set).
    getAvailableLanguages(state, getters, rootState) {
      const general = rootState.settings?.systemSettings?.general ?? {}
      return [
        ...new Set([
          ...(general.available_languages ?? []),
          general.default_language,
          i18n.global.locale
        ])
      ].filter(Boolean)
    },
    // Crema invoices in euros only.
    getDefaultCurrencyMetadata() {
      return 'EUR'
    },
    getAllUsersMetadata(state, getters, rootState) {
      return rootState.user?.usersList ?? []
    }
  }
}
